import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    borderRadius: 5,
    color: '#FFF',
    display: 'flex',
    height: 80,
    justifyContent: 'space-between',
    padding: '15px 55px 15px 24px',
    width: '100%',
    '@media (max-width:960px)': {
      justifyContent: 'space-between',
      paddingLeft: '10%',
      paddingRight: '10%',
    },
  },

  data: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    maxWidth: 300,
    justifyContent: 'space-evenly',

    '&.lateReturn': {
      width: 'auto',
    },
  },

  widgetIcon: {
    color: '#FFF',
    fontSize: 40,
    borderRadius: '50%',
    padding: 8,
    display: 'flex',
    background: `#0176E8 0% 0% no-repeat padding-box`,
    '@media (max-width:1460px)': {
      '& svg': {
        fontSize: 20,
      },
    },
  },

  availableIcon: {
    backgroundColor: theme.palette.statitstics.availableBg,
  },

  inDeliveryIcon: {
    backgroundColor: theme.palette.statitstics.reservedBg,
  },

  reservedIcon: {
    backgroundColor: theme.palette.statitstics.reservedBg,
  },

  offlineIcon: {
    backgroundColor: theme.palette.statitstics.offlineBg,
  },

  lateReturnIcon: {
    backgroundColor: theme.palette.statitstics.lateBg,
  },

  widgetContent: {
    alignItems: 'flex-end',
    display: 'flex',
    flexDirection: 'column',
  },

  widgetValue: {
    fontSize: 24,
    fontWeight: 'bold',
    '@media (max-width:1460px)': {
      fontSize: 22,
    },
  },

  widgetLabel: {
    fontSize: 14,
    fontWeight: 500,
    '@media (max-width:1460px)': {
      fontSize: 13,
    },
    '@media (max-width:1350px)': {
      fontSize: 12,
    },
  },

  reserved: {
    backgroundColor: theme.palette.statitstics.reserved,
  },

  inDelivery: {
    backgroundColor: theme.palette.statitstics.reserved,
  },

  available: {
    backgroundColor: theme.palette.statitstics.available,
  },

  offline: {
    backgroundColor: theme.palette.statitstics.offline,
  },

  lateReturn: {
    backgroundColor: theme.palette.statitstics.late,
  },

  divider: {
    width: 1,
    height: '80%',
    marginLeft: '24px',
    marginRight: '24px',
    '@media (max-width:1460px)': {
      marginLeft: '18px',
      marginRight: '18px',
    },
  },
}));

export default useStyles;
